<div class="container-center">
  <div class="box-1">
   <app-carousel></app-carousel>
   
  </div>
  <div class="box-2">
    <div class="container">
      <form *ngIf="!Form2" class="form-padding" name="abc" (ngSubmit)="onSubmit(feed)" #feed="ngForm">
  <h5>Login</h5>
  <div class="form-group mtop30 mb-0 thumb50 full-width-container" oncontextmenu="false;">
    <div>
          <ngx-intl-tel-input
              [cssClass]="'form-control'"
              [preferredCountries]="['in', 'us']"
              [enableAutoCountrySelect]="false"
              [enablePlaceholder]="true"
              [customPlaceholder]="'Enter phone number'"
              [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
              [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.India"
              [maxLength]="15"
              [phoneValidation]="true"
              [separateDialCode]="true"
              [inputId]="'my-input-id'"
              name="phone"
              *ngIf="loginMethod === 'mobile'"
              [(ngModel)]="phoneNumber"
              (ngModelChange)="checkCountryCode2($event)"
              #fieldReference="ngModel"
              required
            ></ngx-intl-tel-input>
    </div>

    <!-- Edit / Switch Login Options -->
    <small class="form-text float-right green cursor"
      *ngIf="loginMethod=='mobile' && showEditOption=='mobile'"
      (click)="changePhoneNumber();">Edit number?</small>
    <small *ngIf="showEmailOrMobile=='email'" class="form-text float-right green cursor"
      (click)="showLoginOption('email')">Use Email</small>

    <!-- Email Input -->
    <input *ngIf="loginMethod=='email'" [disabled]="OTPGenerated || validatePassword" required type="email"
      class="form-control height50" id="email" aria-describedby="emailHelp1"
      pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" name="email" placeholder="Enter Email ID"
      [(ngModel)]="email" (focus)="clearServerErr($event)"><br />

    <small *ngIf="showEmailOrMobile=='mobile'" class="form-text float-right green cursor"
      style="margin-top: -15px" (click)="showLoginOption('mobile')">Use Mobile Number</small>
    <small class="form-text float-right green cursor" style="margin-top: -13px"
      *ngIf="loginMethod == 'email' && showEditOption=='email'" (click)="changePhoneNumber();">Edit Email?</small>
  </div>

  <br>
  <div>
    <small style="font-size:14px;" *ngIf="unRegisteredUserFlag" class="text-danger">{{errmsgMobile}}</small>
  </div>

  <!-- Login Button -->
  <div class="loginBtn" *ngIf="loginButton">
    <button (click)="getCompanyList();" [disabled]="feed.invalid" type="submit" id="submit"
      class="btn btn-login mtop15">Next</button>
  </div>

  <p *ngIf="!OTPGenerated && !validatePassword" class="mtop30">
    Don’t have an account? <a routerLink="/register" class="text-info">Sign Up</a>
  </p>

  <!-- ✅ OTP Section (if generated) -->
  <div *ngIf="OTPGenerated" class="form-group mtop15">
    <label *ngIf="loginMethod == 'mobile'">Enter the OTP sent to your registered mobile number</label>
    <label *ngIf="loginMethod == 'email'">Enter the OTP sent to your registered Email ID</label>

    <div class="input-group mb-1 otp-input-group" id="otpvalidate">
      <input type="text" maxlength="1" class="form-control verifyGrid"
        [(ngModel)]="otpDigit1" name="digit1" id="digit1"
        (input)="changeFocus($event, 'digit2')" 
        (keydown)="backspaceFocus($event)" autofocus>
      <input type="text" maxlength="1" class="form-control verifyGrid"
        [(ngModel)]="otpDigit2" name="digit2" id="digit2"
        (input)="changeFocus($event, 'digit3', 'digit1')" 
        (keydown)="backspaceFocus($event, 'digit1')">
      <input type="text" maxlength="1" class="form-control verifyGrid"
        [(ngModel)]="otpDigit3" name="digit3" id="digit3"
        (input)="changeFocus($event, 'digit4', 'digit2')" 
        (keydown)="backspaceFocus($event, 'digit2')">
      <input type="text" maxlength="1" class="form-control verifyGrid"
        [(ngModel)]="otpDigit4" name="digit4" id="digit4"
        (input)="changeFocus($event, 'digit5', 'digit3')" 
        (keydown)="backspaceFocus($event, 'digit3')">
      <input type="text" maxlength="1" class="form-control verifyGrid"
        [(ngModel)]="otpDigit5" name="digit5" id="digit5"
        (input)="changeFocus($event, 'digit6', 'digit4')" 
        (keydown)="backspaceFocus($event, 'digit4')">
      <input type="text" maxlength="1" class="form-control verifyGrid"
        [(ngModel)]="otpDigit6" name="digit6" id="digit6"
        (input)="changeFocus($event, '', 'digit5')" 
        (keydown)="backspaceFocus($event, 'digit5')">
    </div>

    <small class="text-danger mt-0 mb-0"> {{OTPerror}} </small>

    <div class="col" *ngIf="showTimer">
      <div class="clock float-right text-center">
        <h4 class="green">0{{minute}}:<span *ngIf="secondsvalue">0</span>{{seconds}}</h4>
      </div>
    </div>

    <div id="message" name="message" style="display: none">
      <small style="color: green">{{message}}</small>
    </div>

    <button *ngIf="!showResend" [disabled]="!feed.valid" type="submit" class="btn btn-login mtop30"
      (click)="loginByOtp();clearServerErr($event);">Login</button>

    <button *ngIf="showResend" type="submit" class="btn btn-login mtop30"
      (click)="resendOTP();clearServerErr($event);">Resend OTP</button>
  </div>
</form>


     <form *ngIf="Form2 && !unRegisteredUserFlag" class="form-padding" name="abc" (ngSubmit)="onSubmit(feed1)"
  #feed1="ngForm">
  <h5>Login</h5>
  <div class="form-group mtop30 mb-0 full-width-container" oncontextmenu="false;">

    <!-- Phone / Email input -->
    <div class="phone-wrapper">
      <ngx-intl-tel-input style="pointer-events:none;" *ngIf="loginMethod=='mobile'" [(ngModel)]="phoneNumber"
        (ngModelChange)="checkCountryCode2($event)" [preferredCountries]="['in', 'us']"
        [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [customPlaceholder]="'Enter phone number'" [searchCountryFlag]="true"
        [searchCountryField]="['name', 'dialCode', 'iso2']" [selectFirstCountry]="false" [separateDialCode]="true"
        [selectedCountryISO]="CountryISO.India" [phoneValidation]="true" name="phone_number"
        required>
      </ngx-intl-tel-input>
    </div>

    <small class="form-text float-right green" style="cursor: pointer;"
      *ngIf="loginMethod=='mobile' || showEditOption=='mobile'" href="/"
      (click)="changePhoneNumber();showCompany=false;OneCompany=false">Edit number?</small>

    <input *ngIf="loginMethod=='email'" disabled required type="text" class="form-control height50" id="email"
      aria-describedby="emailHelp1" pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" name="email"
      placeholder="Enter Email ID" [(ngModel)]="email" (focus)="clearServerErr($event)"><br />

    <small class="form-text float-right green" style="cursor: pointer;margin-top: -13px"
      *ngIf="loginMethod == 'email' || showEditOption=='email'" href="/" (click)="changePhoneNumber();">Edit
      Email?</small>
  </div>

  <!-- Company selection -->
  <div *ngIf="showCompany && Form2">
    <div class="form-group mtop30 mb-0 full-width-container">
      <div class="form-group float-label-control">
        <select name="companyList" (change)="selectedCompanyName($event.target.value);"
          placeholder="Select company sector" class="center-block form-control extra"
          [ngStyle]="{'pointer-events': OTPGenerated || validatePassword ? 'none' : 'all'}">
          <option *ngIf="CompanyName==null" selected value="" style="color: #2b669a">select company</option>
          <option *ngIf="CompanyName!=null" selected value="{{companyId}}">{{this.CompanyName}}</option>
          <option *ngFor="let company of companyList" value="{{company._id}}">{{company.companyName}}</option>
        </select>
        <br>
        <small *ngIf="OTPGenerated || validatePassword && companyList.length > 1"
          class="form-text float-right green" style="cursor: pointer;margin-top: -13px" href="/"
          (click)="changeCompany();">Change Company?</small>
        <div *ngIf="!OTPGenerated && !validatePassword">
          <button [ngClass]="{'disabled':companyId== null}" style="margin-top:20px;" class="btn btn-login mtop15"
            (click)="getOtpOrPassword();">Next</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Single company -->
  <div *ngIf="!showCompany && OneCompany && Form2">
    <div class="form-group mtop30 mb-0 full-width-container">
      <div class="form-group float-label-control">
        <select [disabled]='true' name="companyList" class="center-block form-control extra"
          style="pointer-events:none;">
          <option value="companyId">{{CompanyName}}</option>
        </select><br>
        <small *ngIf="companyList.length > 1" class="form-text float-right green"
          style="cursor: pointer;margin-top: -13px" href="/" (click)="changeCompany();">Change Company?</small>
      </div>
    </div>
  </div>

  <!-- OTP section -->
    <div *ngIf="OTPGenerated" class="form-group mtop15">
      <label *ngIf="loginMethod == 'mobile'">Enter the OTP sent to your registered mobile number</label>
      <label *ngIf="loginMethod == 'email'">Enter the OTP sent to your registered Email ID</label>

    <div class="input-group mb-1 otp-input-group" id="otpvalidate">
    <input type="text" maxlength="1" class="form-control verifyGrid"
      [(ngModel)]="otpDigit1" name="digit1" id="digit1"
      (input)="changeFocus($event, 'digit2')" 
      (keydown)="backspaceFocus($event)" autofocus>

    <input type="text" maxlength="1" class="form-control verifyGrid"
      [(ngModel)]="otpDigit2" name="digit2" id="digit2"
      (input)="changeFocus($event, 'digit3', 'digit1')" 
      (keydown)="backspaceFocus($event, 'digit1')">

    <input type="text" maxlength="1" class="form-control verifyGrid"
      [(ngModel)]="otpDigit3" name="digit3" id="digit3"
      (input)="changeFocus($event, 'digit4', 'digit2')" 
      (keydown)="backspaceFocus($event, 'digit2')">

    <input type="text" maxlength="1" class="form-control verifyGrid"
      [(ngModel)]="otpDigit4" name="digit4" id="digit4"
      (input)="changeFocus($event, 'digit5', 'digit3')" 
      (keydown)="backspaceFocus($event, 'digit3')">

    <input type="text" maxlength="1" class="form-control verifyGrid"
      [(ngModel)]="otpDigit5" name="digit5" id="digit5"
      (input)="changeFocus($event, 'digit6', 'digit4')" 
      (keydown)="backspaceFocus($event, 'digit4')">

    <input type="text" maxlength="1" class="form-control verifyGrid"
      [(ngModel)]="otpDigit6" name="digit6" id="digit6"
      (input)="changeFocus($event, '', 'digit5')" 
      (keydown)="backspaceFocus($event, 'digit5')">
  </div>


      <small class="text-danger mt-0 mb-0">{{ OTPerror }}</small>

      <div class="col" *ngIf="showTimer">
        <div class="clock float-right text-center">
          <h4 class="green">0{{minute}}:<span *ngIf="secondsvalue">0</span>{{seconds}}</h4>
        </div>
      </div>

      <div id="message" name="message" style="display: none">
        <small style="color: green">{{message}}</small>
      </div>

      <button *ngIf="!showResend" [disabled]="otpDigit1=='' || otpDigit2=='' || otpDigit3=='' || otpDigit4=='' || otpDigit5=='' || otpDigit6==''"
        type="submit" class="btn btn-login mtop30" (click)="loginByOtp();clearServerErr($event);">Login</button>

      <button *ngIf="showResend" type="submit" class="btn btn-login mtop30" (click)="resendOTP();clearServerErr($event);">Resend OTP</button>
    </div>

  <!-- Password section -->
    <div *ngIf="validatePassword" class="login-button">
      <div class="input-group login-input-group">
        <input appPassword type="password" class="form-control form-login rbw-0 height50" id="exampleInputPassword1"
          (input)="clearServerErr($event);" name="validPassword" #pass="ngModel" placeholder="Password"
          [(ngModel)]="validPassword" required>
      </div>
      <small class="form-text float-right green" style="cursor: pointer;font-size: 12px" *ngIf="validatePassword"
        (click)="switchOtp();">Use OTP</small>

      <div>
        <small class="text-danger" *ngIf="passwordErrFlag">{{passworderror.message}}</small>
      </div>

      <button type="submit" [disabled]="disableLogin||feed1.invalid" class="btn btn-login mtop30"
        id="validatedPassword" (click)="loginByPassword();clearServerErr($event);">Login</button>
    </div>
</form>




    </div>
  </div>
</div>